import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { Link } from "react-router-dom";
import { showDialog } from "../../Actions/DialogActions";
import { ApplicationDetails } from "./ApplicationDetails";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector>;

export type ApplicationType = {
    name: string;
    redirect: string;
    client_id: string;
    embedded: string;
};

interface Props extends PropsFromRedux {
    index: number;
    application: ApplicationType;
}

class ApplicationLine extends React.Component<Props> {
    public onDetails = (): void => {
        const clientID = this.props.application.client_id;

        this.props.dispatch(showDialog(
            "Application Details",
            <ApplicationDetails client={clientID} />
        ));
    };

    public render(): React.ReactNode {
        const { name, redirect, client_id } = this.props.application;

        return (
            <tr>
                <td className="name">{name}</td>
                <td className="expand">{redirect}</td>
                <td className="actions">
                    <span className="action" onClick={this.onDetails}>Details</span>
                    <Link to={`/application/${client_id}/edit`} className="action">Edit</Link>
                    <Link to={`/application/${client_id}/history`} className="action">History</Link>
                </td>
            </tr>
        );
    }
}

export default connector(ApplicationLine);
